import { NumberField } from '@hb/shared'
import { forwardRef } from 'react'
import { InputElement, InputProps } from '../../../../types/fields'
import { BaseNumberInput } from './BaseNumberInput'

export const NumberInput: InputElement<NumberField> = forwardRef<
  HTMLInputElement,
  InputProps<NumberField>
>(({ style, ...props }, ref) => {
  const { input, field, disabled, readOnly, inputStyle, meta } = props
  const { min, max, optional, defaultValue, step, precision, unit, placeholder } = field

  const { value, onChange } = input

  return (
    <BaseNumberInput
      field={field}
      meta={meta}
      input={input}
      disabled={disabled}
      readOnly={readOnly}
      value={value}
      style={style}
      inputStyle={inputStyle}
      placeholder={placeholder}
      onChange={(asString, asNumber) => {
        if (field.precision) {
          onChange({ target: { value: asString } })
        } else {
          onChange({ target: { value: asString && !isNaN(asNumber) ? asNumber : undefined } })
        }
        // onChange({ target: { value: field.precision ? asString : asNumber } })
      }}
      ref={ref}
      min={min}
      max={max}
      optional={optional}
      defaultValue={defaultValue}
      step={step}
      precision={precision}
      unit={unit}
    />
  )
})
